import { contextFactory } from '@frontend/design-system';
import { usePlatformComponentContext } from '../../../contexts/platform-component.context';
import { useProcessorDataContext } from '../../../contexts/processor-data.context';
import { usePaymentMethodsStripe } from '../hooks/use-payment-methods-stripe';
import { usePaymentMethodsStripeApi } from '../hooks/use-payment-methods-stripe-api';
import { useSelectDefaultPaymentMethod } from '../hooks/use-select-default-payment-method';
import { PaymentMethodsAdditionalStripeContext, PaymentMethodsBaseContext } from '../types/provider.types';
import { usePaymentMethodsStateContext } from './payment-methods-state.context';
import { PaymentMethodsProviderProps } from './payment-methods.context';

export type PaymentMethodsStripeContextValue = PaymentMethodsBaseContext & PaymentMethodsAdditionalStripeContext;

export const [PaymentMethodsStripeContext, usePaymentMethodsStripeContext] =
  contextFactory<PaymentMethodsStripeContextValue>('', {} as PaymentMethodsStripeContextValue);

export type PaymentMethodsStripeProviderProps = PaymentMethodsProviderProps;

export const PaymentMethodsStripeProvider = ({ children, isPublic, ...props }: PaymentMethodsStripeProviderProps) => {
  const { locationId, isRegularLocation } = usePlatformComponentContext();

  const {
    stripeData: { enableAchOnFile, enableAddAchMethod },
  } = useProcessorDataContext();

  const api = usePaymentMethodsStripeApi({ isPublic });

  const { selectedPaymentMethod, setSelectedPaymentMethod, setView, setIsResendVerificationAchMode } =
    usePaymentMethodsStateContext();

  const value = usePaymentMethodsStripe({
    ...props,
    locationId,
    isRegularLocation,
    api,
    selectedPaymentMethod,
    enableAchOnFile,
    enableAddAchMethod,
    onSelectPaymentMethod: setSelectedPaymentMethod,
    onChangeView: setView,
    onChangeResendVerificationAchMode: setIsResendVerificationAchMode,
  });

  useSelectDefaultPaymentMethod({
    onSelectPaymentMethod: value.onSelectPaymentMethod,
    selectedPaymentMethod,
    defaultPaymentMethod: value.defaultPaymentMethod,
  });

  return <PaymentMethodsStripeContext.Provider value={value}>{children}</PaymentMethodsStripeContext.Provider>;
};
